import { Language } from '~/types/api/users'

const SUPPORTED_LANGUAGE: Language[] = ['ja', 'ko', 'en', 'th', 'id']

export function isSupportedLanguage(language: string): boolean {
  // 型推論の関係でアサーション
  return (SUPPORTED_LANGUAGE as string[]).includes(language)
}
